export default __webpack_public_path__ + "images/675e8240dca54d4ea7bf75f9eb1e4c38-knitting.jpg";